import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import useGetPurchasableFarData from "../../../../TCPForms/formComponents/purchasableFAR/useGetPurchasableFarData";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import useLocalizedData from "../../../../../../utils/hooks/useLocalizedData";
import { farPrimaryLabels, farSubTabLabels, SideBarLabelsFAR } from "../../../components/data";
import { useQuery } from "react-query";

const usePurchasableFarLogic = () => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("PURCHASABLE_FAR_TAB") || 0);
  const [subActiveTab, setSubActiveTab] = useState(Digit?.SessionStorage.get("PURCHASABLE_FAR_SUBTAB") || 0);

  const [assignLTP, setAssignLTP] = useState("No");
  const [usersData, setUsersData] = useState({});
  const [isUserEligible, setIsUserEligible] = useState(true);
  // const [allUsersData, setAllUsersData] = useState([]);
  //Initialisation
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { authority, plan, form, year, serial, formType } = useParams(); //:authority/:plan/:form/:year/:serial
  console.log(useParams(), "paramsHook");
  const id = authority ? `${authority}/${plan}/${form}/${year}/${serial}` : undefined;
  const history = useHistory();
  //Async network calls
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { data: cities, isLoading } = Digit.Hooks.useTenants();
  const { data: { BPA: { ProposedActivityPurchasableFAR: pFarList } = {} } = {}, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["ProposedActivityPurchasableFAR"]
  );
  console.log("pFarData", pFarList);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");

  // const { data = {}, isLoading: loader, refetch } = Digit.Hooks.obps.useBPADetailsPage(
  //   tenantId,
  //   { applicationType: "FORM_LANDUSE" },
  //   { formType: "formLandUse" }
  // );
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const { info: userInfo = {} } = Digit.UserService.getUser();
  const { documents } = useSelector((state) => state.formMT);
  console.log("dataLandUSeSearch", "params", id);
  // const approvedLandUse = data?.LandUse?.filter((item) => item.status === "APPROVED"); //filter the approved files
  // const approvedApplicationNumbers = approvedLandUse?.map((item) => ({
  //   name: item.applicationNo,
  //   label: item.applicationNo,
  //   value: item.applicationNo,
  // }));
  const useGetPurchasableFarData = (id = null) => {
    if (id) {
      console.log("insdieifhook call", typeof id, id);

      const fetchApplicationData = async () => {
        return await Digit.OBPSService.BPASearchPurchasableFAR(tenantId, { applicationNo: id });
      };

      const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });
      const applicationData = isSuccess && data?.PurchasableFAR?.[0];
      console.log("insdieifhook call", applicationData);
      return { applicationData, isAppDataLoading };
    }

    const userUid = userInfo?.uuid;
    const applicationType = "FORM_PURCHASABLE_FAR";

    async function searchUser() {
      try {
        const response = await Digit.UserService.userSearch(tenantId, { uuid: [userUid] }, {});
        const allUsers = await Digit.UserService.allUsersSearch(tenantId, {}, {});
        console.log("searchUser:", response);
        console.log("searchUser2:", allUsers);
        setUsersData(response);
        // setAllUsersData(allUsers?.user);
        return response;
      } catch (error) {
        console.error("Error during user search:", error);
      }
    }
    useEffect(() => {
      searchUser();
    }, [id]);

    const applicationData = {
      tenantId: tenantId,
      selectedOffice: null,
      assignLTP: null,
      professionalInformation: {
        ltpName: null,
        ltpMobileNumber: null,
        ltpUuid: null,
        ltpRegistrationNumber: null,
        ltpCity: null,
        applicantName: null,
        applicantMobileNumber: null,
      },
      descriptionOfLand: {
        googleMapCoordinates: null,
        googleMapLocation: null,
        properties: [
          {
            constructionType: null,
            sectorNo: null,
            propertyNo: null,
            schemeName: null,
            block: null,
            khataNo: null,
            khasraNo: null,
            khatauniNo: null,
            landWidth: null,
            plotArea: 0,
            plotNo: null,
            schemeRate: 0,
            takenFAR: null,
            baseFAR: 0,
            circleRate: 0,
            maxPermissibleFar: null,

            factor: 0,
            roadWidth: null,
            subLandUseAsPerLayout: null,
            permissibleFAR: null,
            permissibleGroundCoverage: null,
            purchasableFAR: null,
            percentRequiredFAR: null,
            requiredAreaFAR: null,
            landUseAsPerLayout: null,
            // landUseMasterPlan: null,
            propertyType: {
              name: null,
            },
          },
        ],
      },

      checklist: {
        firstCheckList: {
          setbackPosition: {
            front: null,
            rear: null,
            left: null,
            right: null,
          },
          buildingHeight: null,
          structuralSafety: null,
          totalParkingRequired: null,
          parkingProvision: {
            inBasement: {
              cars: null,
              ecs: null,
            },
            openArea: {
              cars: null,
              ecs: null,
            },
            inStiltArea: {
              cars: null,
              ecs: null,
            },
          },
        },
        secondCheckList: {
          publicSewerageOrSepticTank: null,
          drainagePlanApproval: null,
          existingRoadWidth: null,
          minimum24MetersWide: null,
          waterSupplyArrangement: null,
          waterSupplyPlanApproval: null,
          stpSepticTankArrangement: null,

          connectivityWithGovernmentAuthority: null,
          drainageSystemComplianceWithStandards: null,
          drainageAsPerStandards: null,
          totalEstimatedPowerDemand: null,
          powerSupplyConsent: null,
          rooftopAreaAndDrainage: null,
          drainageStandardsCompliance: null,
          solarWaterHeatingProvision: null,
          buildingByeLawsCompliance: null,
        },
      },
      checklistReview: {
        firstCheckList: {
          setbackPosition: {
            front: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            rear: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            left: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            right: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          buildingHeight: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },

          proposalDocument: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },
          drawingFile: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },

          structuralSafety: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },
          structuralSafetyCert: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },
          fireDepartmentCert: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },
          totalParkingRequired: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null,
          },
          parkingProvision: {
            inBasement: {
              cars: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null,
              },
              ecs: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null,
              },
            },
            openArea: {
              cars: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null,
              },
              ecs: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null,
              },
            },
            inStiltArea: {
              cars: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null,
              },
              ecs: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null,
              },
            },
          },
        },
        secondCheckList: {
          sewerage: {
            publicSewerageOrSepticTank: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            drainagePlanApproval: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          roadConnectivity: {
            existingRoadWidth: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            minimum24MetersWide: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          waterSupply: {
            waterSupplyArrangement: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            waterSupplyPlanApproval: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          sewerageDisposal: {
            stpSepticTankArrangement: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            connectivityWithGovernmentAuthority: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          drainageSystemCompliance: {
            systemAsPerStandards: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            drainageAsPerStandards: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          powerSupply: {
            totalEstimatedPowerDemand: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            powerSupplyConsent: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          rooftopRainwaterHarvesting: {
            areaAndDrainage: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            drainageStandardsCompliance: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
          solarWaterSystem: {
            provisionForPipes: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
            buildingByeLawsCompliance: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null,
            },
          },
        },
        currentEmpRole: null,
        lastEmpRole: null,
      },

      applicationType,
      approvedLayout: null,
      feeType: "ApplicationFee",
      department: applicationFlow,
      workflow: { action: "INITIATE", assignes: [userUid] },
      landInfo: {
        tenantId: tenantId,

        address: {
          tenantId,
          locality: {
            code: "Agra",
          },
        },
        owners: [
          {
            name: null,
            fatherOrHusbandName: null,
            aadhaarNumber: "",
            mobileNumber: "",
            emailId: "",
            gender: null,
            correspondenceAddress: {
              applicantName: null,
              applicantGuardianName: null,
              state: "Uttar Pradesh",
              district: null,
              tehsil: null,
              town: null,
              address: "",
              pinno: "",
              type: "CORRESPONDENCE",
            },
            permanentAddress: {
              applicantName: null,
              applicantGuardianName: null,
              state: "Uttar Pradesh",
              district: null,
              tehsil: null,
              town: null,
              address: "",
              pinno: "",
              type: "PERMANENT",
            },
            bankdetails: {
              accountHolderName: null,
              branchName: null,
              ifscCode: null,
              accountNo: null,
              bankName: null,
            },
          },
        ],
      },
      businessService: null,
      documents,
      uiFlow: { flow: "FORM_PURCHASABLE_FAR" },
    };

    return { applicationData, isAppDataLoading: false };
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  const { applicationData, isAppDataLoading } = useGetPurchasableFarData(id);
  console.log("approvedLandUSe", applicationFlow);

  const userUid = userInfo?.uuid;

  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_PURCHASABLE_FAR", applicationData);
  const isSessionCleared = useRef(false);
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    console.log("nextTabReceived", nextTabNo, activeTab);

    if (formData) {
      const data = { ...params, ...formData };

      console.log(formData, params, data, "fromHandleTabCHange");

      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in formData)) {
        const data = { ...applicationData, ...formData };
        console.log("fromCreatePayload", data);

        Digit.OBPSService.createPurchasableFAR({ PurchasableFAR: data }, tenantId)
          .then((res) => {
            console.log(res.data, res, "promise");

            const result = res.PurchasableFAR?.[0];
            if (res?.PurchasableFAR?.length > 0) {
              onSelect("", { ...formData, ...result }, true);
              // Modal("Application Created.", `Application Created Successfully!`, "success");
              setShowToast({ key: "success", message: `Application Created Successfully!` });
              setActiveTab(nextTabNo);
              sessionStorage.setItem("currentTab", nextTabNo);
              Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
            }
          })
          .catch((e) => {
            setShowToast({ error: true, message: e?.response?.data?.Errors[0]?.message });
          });
      } else {
        try {
          if (activeTab === 4 && assignLTP === "No") {
            data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null }; // In case LTP is not assigned.
          } else if (activeTab === 4 && assignLTP === "Yes" && isAssignedLTP) {
            data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null }; // In case LTP is submitting the file
          } else if (activeTab === 4 && assignLTP === "Yes" && !isAssignedLTP) {
            data.workflow = { action: "FORWARD_TO_LTP", assignes: null }; // In case LTP is assigned and owner is submitting the file
          } else if (activeTab === 3) {
            data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
          } else {
            data.workflow = { action: "UPLOAD_DOC", assignes: [userUid] }; // Normal update call
          }

          updateApiCall.mutate(
            { PurchasableFAR: data },
            {
              onSuccess: () => {
                onSelect("", data);
                if (activeTab == 3) {
                  Modal(
                    "Application submitted.",
                    `Application <strong>${data?.applicationNo}</strong> Submitted Successfully!`,
                    "success",
                    "/digit-ui/citizen/profile",
                    closeModal
                  );
                  // setShowToast({ key: "success", message: `Application <strong>${data?.applicationNo}</strong> Submitted Successfully!` });
                  clearParams();
                  Digit?.SessionStorage.del("FORM_PURCHASABLE_FAR");
                  Digit?.SessionStorage.del("PURCHASABLE_FAR_TAB");
                  Digit?.SessionStorage.del("PURCHASABLE_FAR_SUBTAB");
                  // history.push("/digit-ui/citizen/profile");
                } else {
                  // Modal("Application Updated.", `Application Updated Successfully!`, "success");
                  setShowToast({ key: "success", message: `Application Updated Successfully!` });

                  setActiveTab(nextTabNo);
                  sessionStorage.setItem("currentTab", nextTabNo);
                  Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
                }
              },
              onError: (error) => {
                const errorObject = JSON.parse(error?.message);
                if (errorObject.code === "InvalidInputException") {
                  setShowToast({ error: true, message: `${errorObject.description}` });

                  // Modal("Invalid request.", `${errorObject.description}`, "error");
                }
              },
            }
          );
        } catch (error) {
          console.error(e);
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
      }
    } else {
      console.log("inside handle change else");
      if (assignLTP === "Yes" && nextTabNo === 2 && !isAssignedLTP) {
        setActiveTab(5);
        sessionStorage.setItem("currentTab", 5);
        Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", 5);
      } else {
        setActiveTab(nextTabNo);
        sessionStorage.setItem("currentTab", nextTabNo);
        Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
      }
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("insdieSubttab", nextSubTab, activeTab, subActiveTab, formData);

    if (formData) {
      const data = { ...params, ...formData };
      console.log("insideIfSubTabhandler", formData, data, params);
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNo" in params)) {
        console.log("dataFromIf", data);

        Digit.OBPSService.createPurchasableFAR({ PurchasableFAR: data }, tenantId)
          .then((result) => {
            if (result?.PurchasableFAR?.length > 0) {
              console.log("farResult", result?.PurchasableFAR);

              onSelect("", { ...formData, ...result.PurchasableFAR[0] }, "", true);
              // Modal("Application created.", `Application Created Successfully!`, "success");
              setShowToast({ key: "success", message: `Application Created Successfully!` });

              setSubActiveTab(nextSubTab);
              Digit.SessionStorage.set("PURCHASABLE_FAR_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            setShowToast({ error: true, message: `Something went wrong!` });

            // Modal("Create Error.", `Something went wrong!`, "error");
          });
      } else {
        try {
          console.log("insideELse", data);
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { PurchasableFAR: data },
            {
              onSuccess: (result) => {
                if (result?.PurchasableFAR?.length > 0) {
                  onSelect("", result.PurchasableFAR[0]);
                  // Modal("Application updated.", `Application Updated Successfully!`, "success");
                  setShowToast({ key: "success", message: `Application Updated Successfully!` });

                  setSubActiveTab(nextSubTab);
                  Digit.SessionStorage.set("PURCHASABLE_FAR_SUBTAB", nextSubTab);
                }
              },
              onError: () => {
                // Modal("Update Error1", `Something went wrong!!`, "error");
                setShowToast({ error: true, message: `Something went wrong!!` });
              },
            }
          );
        } catch (error) {
          // Modal("Update Error.", `Something went wrong!!`, "error");
          setShowToast({ error: true, message: `Something went wrong!` });
        }
      }
    } else {
      console.log("inElseSubtab", nextSubTab);

      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("PURCHASABLE_FAR_SUBTAB", nextSubTab);
    }
  };
  const { FAR_SB, FAR_PT, FAR_ST } = useLocalizedData({
    FAR_SB: SideBarLabelsFAR,
    FAR_PT: farPrimaryLabels,
    FAR_ST: farSubTabLabels,
  });
  // const isPrefillContext = window.location.search.includes("prefill=true");
  // console.log("isPrefillContext", isPrefillContext, "isSessionCleared", isSessionCleared);
  const avpAuthorityList =
    !isLoading && applicationFlow
      ? cities?.filter((district) => district?.code?.includes("up.avp"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
      : [];

  const daAuthorityList =
    !isLoading && applicationFlow
      ? cities?.filter((district) => district?.code?.includes("up.da"))?.[0]?.boundary?.filter((ele) => ele.hasOwnProperty("location"))
      : [];
  console.log("authorityList", avpAuthorityList, daAuthorityList);

  // Function to filter office names
  const filterOfficeNames = (completeList) => {
    const officeNames = completeList.map((office) => ({ value: office.name, label: office.name }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  };
  const officesList = applicationFlow === "DA" ? filterOfficeNames(daAuthorityList) : filterOfficeNames(avpAuthorityList);
  console.log("applicationData", applicationData, "fromFAR");
  const summaryRef = useRef();
  const [showToast, setShowToast] = useState(null);

  const Modal = useModal();
  const closeModal = () => {
    console.log("triggeredCloseModal");

    clearParams();
    // sessionStorage.clear("Digit.FORM_PURCHASABLE_FAR");
    sessionStorage.removeItem("currentTab");
    sessionStorage.removeItem("currentCity");
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
    setTimeout(() => {
      resetFormMTDocs();
    }, 0);
    setShowToast(null);
  };
  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  return {
    activeTab,
    setActiveTab,
    assignLTP,
    setAssignLTP,
    dispatch,
    t,
    id,
    history,
    initFormMTDocs,
    resetFormMTDocs,
    isUdFlow,
    applicationFlow,
    userUid,
    params,
    setParams,
    clearParams,
    isSessionCleared,
    isAppDataLoading,
    summaryRef,
    showToast,
    Modal,
    closeModal,
    handleTabChange,
    handleSubTabChange,
    applicationData,
    userInfo,
    tenantId,
    FAR_SB,
    FAR_PT,
    subActiveTab,
    setSubActiveTab,
    FAR_ST,
    isUserEligible,
    setIsUserEligible,
    officesList,
    DepartmentSelector,
    closeToast,
    setShowToast,
    pFarList,
  };
};
export default usePurchasableFarLogic;
